import { combineEpics } from 'redux-observable';
import { getPresetsEpic } from './get-presets';
import { getPresetsOnActiveEpic } from './get-presets-on-active';
import { updatePresetsEpic } from './update-presets';

const artistPresetsEpic = combineEpics(
  getPresetsOnActiveEpic,
  getPresetsEpic,
  updatePresetsEpic
);

export default artistPresetsEpic;
